'use client';

import Link from 'next/link';
import { AppIcon } from '@/icons/AppIcon';
import { useRouter } from 'next/navigation';
import { appRPC } from '@/lib/utils';
import { WebLink } from '@/lib/WebLinks';

export default function CheckoutHeader({ isApp = false }: { isApp?: boolean }) {
  const router = useRouter();

  const handleAppStoreRedirect = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isApp) {
      const RPCcheck = appRPC('route', 'routeChanged', WebLink.HOME);
      if (!RPCcheck && window) {
        window.location.href = WebLink.HOME;
        return;
      } else if (RPCcheck) {
        return;
      }
    }

    router.push(WebLink.HOME);
  };

  return (
    <header
      className={`hc-checkout-sticky sticky top-0 z-50 transition-colors duration-300 ease-in-out bg-hzc_purple_500 flex w-full`}
    >
      <div className="flex h-24 max-w-7xl mx-auto">
        <Link
          onClick={(e) => {
            handleAppStoreRedirect(e);
          }}
          href={'#'}
          className="flex items-center mx-auto"
        >
          <AppIcon className="h-9 sm:h-12 self-center" />
        </Link>
      </div>
    </header>
  );
}
